import {Component, OnInit, ViewChild} from '@angular/core';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {Observable} from 'rxjs/Observable';



@Component({
  selector: 'app-student-profile',
  templateUrl: './subject-assign.component.html',
  styleUrls: ['./subject-assign.component.css']
})

export class SubjectAssignComponent implements OnInit {
  public SchoolYear: any;
  public selectedYear: any;
  public ShowLevelData: any;
  public selectedlevel: string = '';
  public section: any;
  public selectedgrade:  any;
  public selectedTeacher:  any;
  public selectedsection:  any;
  public grade: any = [];
  selectedSubject: any = "All Subjects";
  subjects: any = [];
  subjectsList: any = [];
  public mappedData: any;
  nameofsec: any = [];
  sectionId: any = []
  sectionList: any = [];
  public TeacherDetailsData: any = [];
  public TeacherTableData: any = [];
  public display;
  public schoolId: any;
  public selectedsub: any;
  public selectedsec: any;
  public test: 1;




  public selectedTitle: any;
  public enteredFirstName: string;
  public enteredLastName: string;
  public enteredMiddleName: string;
  public enteredEmail: string;
  public enteredPhone: string;

  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {
    this.schoolId = this.localStorage.retrieve('schoolid');
    //this.userId = this.localStorage.retrieve('CurrentChildId');
  }
  ngOnInit() {
    this.getAcademicYear();
  }

  /*------------------------getAcademicYear-----------------------*/
  private getAcademicYear() {
    this.dataAnalyticsService
      .getAcadamicYearOfyears()
      .finally(() => {})
      .subscribe(
        (response) => {
          this.SchoolYear = response["yearList"];
          console.log("SchoolYear", this.SchoolYear);
          this.SchoolYear.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));

          try {
            //this.selectedYear = this.SchoolYear[0].YearId
            this.getTeacherDetails();
          } catch (error) {}
        },
        (error) => {
          this.SchoolYear = [];
          console.error(error);
        }
      );
  }
  changeYear(){
    console.log("selectedYear",this.selectedYear)

  }
//-----------------------------------------------------------------------------------------------------------



  private getTeacherDetails() {
    this.dataAnalyticsService
      .getDropDownTeacherDetails()
      ._finally(() => {})
      .subscribe((response) => {
        this.TeacherDetailsData = response["Value"];
        console.log("getTeacherDetails", this.TeacherDetailsData);
        try {
          //this.selectedTeacher = this.TeacherDetailsData[0].TeacherId;
          this.getLevelsName();
        } catch (error) {}
      });
  }

  changeteacher(){
    console.log("selectedTeacher",this.selectedTeacher)
  }
  //------------------LEVEL Primary, secondary----------------------------------------------------------------


  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        console.log("LevelData", this.ShowLevelData);
        try {
          //this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);
        } catch (error) {}
      });
  }

  getLevelsListById(){
    console.log("Levels", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }

  //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedgrade = mappedData[mappedData.length - 1];
          this.getSectionByGrade(this.selectedgrade);
          //this.selectedsection = this.selectedgrade.Sections[0];
          this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        try {
          this.nameofsec = this.selectedsection.sectionName;
          this.sectionId = this.selectedsection.SectionId;
        } catch (error) {

        }


      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedgrade = null;
        this.selectedsection = null;
        this.selectedSubject = null;
      });
  };

  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    try {
      //this.selectedsection = this.sectionList[0];
      this.getSubjects();
      this.getTeacherTable();

    } catch (error) {

    }
  }

  getGclClassesListById(section) {

    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    this.selectedsec = section.SectionId
    console.log('getGclClassesListById', this.selectedsec);

    this.getSubjects();
  }
  /* -----------------------------GET SUBJECT--------------------------------*/

  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedsection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        try {
          //this.selectedSubject = this.subjectsList[0];
          this.getTeacherTable();
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }

  onSelectedSubject(subject){
    this.selectedsub = subject.SubjectId;
    console.log("onSelectedSubject", this.selectedsub);
  }
  /*----------------------------------------------Teacher Table--------------------------------------------------------------------*/
  private getTeacherTable() {
    this.dataAnalyticsService
      .getTeacherDetailsForSection(this.selectedYear, this.selectedsec)
      ._finally(() => {})
      .subscribe((response) => {
        this.TeacherTableData = response["Value"];
        console.log("getTeacherDetails", this.TeacherTableData);
        /*try {
          this.selectedTeacher = this.TeacherTableData[0].TeacherId;
          this.getLevelsName();
        } catch (error) {}*/
      });
  }

  /*--------------------------------------------------------------------------------------------------------------------------------*/
  postteachersubject() {

    let payload: any = {
      TeacherId: this.selectedTeacher,
      SubjectId: this.selectedSubject.SubjectId,
      SectionId: this.selectedsection.SectionId,
      CreatedBy: 1,
      ModifiedBy: 1,
      AcademicYearId: this.selectedYear,
    }; //now working with these params

    // Assuming payload is sanitized and validated prior to this function.
// If not, it should be validated here to ensure robustness and security.

    console.log("postteachersubject", payload);

    this.dataAnalyticsService.PostTeacherSubject(payload)
      .catch((error: any, caught: Observable<any>) => {
        console.error("An error occurred while posting teacher subject:", error);

        let errorMessage = error.error ? error.error.Msg : "Failed to add Teacher Subject. The teacher is Already Mapped to this Section and Subject.";
        this.messageService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: errorMessage,
        });
        return Observable.throw(error);
      })
      .subscribe(
        (response) => {
          if (response && response.StatusCode === 200) {
            this.messageService.add({
              severity: "success",
              summary: "Talkative Parents",
              detail: "Teacher Subject Added Successfully",
            });
            this.display = "none";
            this.getTeacherTable();
            console.log(response);
          } else {

            this.messageService.add({
              severity: "error",
              summary: "Talkative Parents",
              detail: response.Msg || "Failed to add Teacher Subject.Teacher is Already Mapped to this Section and Subject.",
            });
          }
        },
        (error) => {

        }
      );
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/teacher-details/subject-assign/subject-assign.component.ts